import { render } from "./MapQuintiles.vue?vue&type=template&id=255dfdc6"
import script from "./MapQuintiles.vue?vue&type=script&lang=js"
export * from "./MapQuintiles.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__